import {
  AppBar,
  Box,
  IconButton,
  styled,
  Theme,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { H2 } from "components/Typography";
import { TitleContext } from "contexts/TitleContext";
import MenuIcon from "@mui/icons-material/Menu";
import { FC, useContext } from "react";
import ProfilePopover from "./popovers/ProfilePopover";

interface DashboardNavBarProps {
  setShowMobileSideBar: () => void;
  hideSidebar: boolean;
  isCustomerAccess?: boolean;
}

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  zIndex: 11,
  boxShadow: "none",
  paddingTop: "12px",
  paddingBottom: "12px",
  backdropFilter: "blur(8px)",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(13, 20, 32, 0.75)"
      : "rgba(245, 248, 252, 0.78)",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const StyledToolBar = styled(Toolbar)(({ theme }) => ({
  "@media (min-width: 0px)": {
    paddingLeft: 8,
    paddingRight: 8,
    minHeight: 56,
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: 12,
    paddingRight: 12,
  },
}));

const DashboardNavbar: FC<DashboardNavBarProps> = ({
  setShowMobileSideBar,
  hideSidebar = false,
  isCustomerAccess = false,
}) => {
  const { title } = useContext(TitleContext);
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  if (isCustomerAccess) return <></>;

  if (downSm) {
    return (
      <DashboardNavbarRoot position="sticky">
        <StyledToolBar>
          {!hideSidebar ? (
            <IconButton onClick={setShowMobileSideBar} sx={{ mr: 0.5 }}>
              <MenuIcon />
            </IconButton>
          ) : null}

          <Box flexGrow={1} textAlign="center">
            <img
              src="/static/logo/logo.svg"
              width="100%"
              height="40"
              alt="Logo"
            />
          </Box>

          <ProfilePopover />
        </StyledToolBar>
      </DashboardNavbarRoot>
    );
  }

  return (
    <DashboardNavbarRoot position="sticky">
      <StyledToolBar>
        <H2
          fontSize={22}
          lineHeight={1.2}
          mx={1}
          fontWeight="700"
          color="text.primary"
        >
          {title}
        </H2>

        <Box flexGrow={1} ml={1} />

        <ProfilePopover />
      </StyledToolBar>
    </DashboardNavbarRoot>
  );
};

export default DashboardNavbar;
